<div class="control">
  <fa-icon [icon]="isOpen() ? openIcon : closedIcon" />
  <button [attr.aria-expanded]="isOpen()" aria-controls="summaryExpansion" (click)="isOpen.update((open) => !open)">
    Report Summary
  </button>
</div>
<div id="summaryExpansion" class="expansion gap-3" [class.open]="isOpen()">
  <div class="card in-transit px-3 py-4 rounded my-3">
    <div>In transit</div>
    <div class="fw-bold">{{ summary().inTransit }}</div>
  </div>
  <div class="card picking-up-today px-3 py-4 rounded my-3">
    <div>Picking up today</div>
    <div class="fw-bold">{{ summary().pickingUpToday }}</div>
  </div>
  <div class="card late px-3 py-4 rounded my-3">
    <div>Late</div>
    <div class="fw-bold">{{ summary().late }}</div>
  </div>
</div>
